var types = {
    // state
    READY: "ready",
    STAGE: "stage",
    SCROLL_Y: "scrollY",
    HEADER_HEIGHT: "headerHeight",
    FOOTER_HEIGHT: "footerHeight",
    IS_MENU_OPEN: "isMenuOpen",
    IS_MODAL_OPEN: "isModalOpen",
    LOAD_PROGRESS: "loadProgress",
    MENU_OPEN_PROGRESS: "menuOpenProgress",
    MENU_CLOSE_PROGRESS: "menuCloseProgress",
    MODAL_OPEN_PROGRESS: "modalOpenProgress",
    MODAL_CLOSE_PROGRESS: "modalCloseProgress",
    TRANSITION_PROGRESS: "transitionProgress",
    ENTER_PROGRESS: "enterProgress",
    LEAVE_PROGRESS: "leaveProgress",
    PAGE_NAME: "pageName",
    IS_HOVER_AT_TOP_EXPERIENCE_ITEM: "isHoverAtTopExperienceItem",
    // mutation & action
    SETUP: "setup",
    SET_STAGE_INFO: "setStageInfo",
    SET_SCROLL_INFO: "setScrollInfo",
    BEGIN_SCROLL: "beginScroll",
    END_SCROLL: "endScroll",
    SET_HEADER_HEIGHT: "setHeaderHeight",
    SET_FOOTER_HEIGHT: "setFooterHeight",
    OPEN_MENU: "openMenu",
    CLOSE_MENU: "closeMenu",
    TOGGLE_MENU: "toggleMenu",
    BEGIN_OPEN_MENU: "beginOpenMenu",
    END_OPEN_MENU: "endOpenMenu",
    BEGIN_CLOSE_MENU: "beginCloseMenu",
    END_CLOSE_MENU: "endCloseMenu",
    BEGIN_LOAD: "beginLoad",
    END_LOAD: "endLoad",
    BEGIN_OPEN_MODAL: "beginOpenModal",
    END_OPEN_MODAL: "endOpenModal",
    BEGIN_CLOSE_MODAL: "beginCloseModal",
    END_CLOSE_MODAL: "endCloseModal",
    START_TRANSITION: "startTransition",
    TURN_TRANSITION: "turnTransition",
    COMPLETE_TRANSITION: "completeTransition",
    START_ENTER: "startEnter",
    COMPLETE_ENTER: "completeEnter",
    START_LEAVE: "startLeave",
    COMPLETE_LEAVE: "completeLeave",
    SET_PAGE_NAME: "setPageName",
    ENTER_TOP_EXPERIENCE_ITEM: "enterTopExperienceItem",
    LEAVE_TOP_EXPERIENCE_ITEM: "leaveTopExperienceItem",
};
export default types;
